import React, { useMemo } from 'react'
import AlgoliaConnector, { ConnectorProps as AlgoliaConnectorProps } from '../connectors/Algolia'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import Select from 'components/SA/Select'
import styles from './SelectHitsPerPage.module.scss'

const options = [25, 50, 100]

const SelectHitsPerPage = (props: AlgoliaConnectorProps) => {
  const { hitsPerPage, updateHitsPerPage } = props

  const handleChangeHitsPerPage = ({ value }) => {
    handleScrollToTop(() => updateHitsPerPage(value))
  }

  const numberOfHitsArray = useMemo(() => {
    return options.map((numberResults) => ({
      label: `${numberResults} Results Per Page`,
      value: `${numberResults}`,
    }))
  }, [])

  const selectValue = numberOfHitsArray.find(({ value }) => value === `${hitsPerPage}`)

  return (
    <div className={styles.selectContainer}>
      <Select
        value={selectValue}
        onChange={handleChangeHitsPerPage}
        aria-label='Hits Per Page'
        dataSection='hits-per-page'
        options={numberOfHitsArray}
      />
    </div>
  )
}

export default AlgoliaConnector(SelectHitsPerPage)
